import artifact from '$houdini/artifacts/AddChartToReportMutation'
import { MutationStore } from '../runtime/stores/mutation'

export class AddChartToReportMutationStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
